import { LoadingState } from '@vista-digital/utilities';
import { useCallback, useEffect, useState } from 'react';
/**
 * Loads an action on mount, or on refresh. Returns the actions LoadActionState.
 * @param loadAction The asynchronous load method. Must be wrapped in useCallback if using an inline function to prevent unnecessary re-renders.
 * @param onError The optional function to be called when `loadAction` fails.
 *
 * For example:
 * ```typescript
 * // Basic
 * const { loadingState } = useLoadAction(loyaltyDomain.actions.member.loadMember);
 *
 * // With callback
 * const loadAction = useCallback(() => {
 *     browsingDomain.actions.films.loadFilmById(filmId), [filmId]);
 * });
 * const { loadingState } = useLoadAction(loadAction);
 * ```
 */
export const useLoadAction = (loadAction, onError) => {
    const [loadingState, setLoadingState] = useState(LoadingState.Loading);
    const loadCallback = useCallback(() => {
        (async () => {
            try {
                setLoadingState(LoadingState.Loading);
                await loadAction();
                setLoadingState(LoadingState.Success);
            }
            catch (error) {
                setLoadingState(LoadingState.Failure);
                onError === null || onError === void 0 ? void 0 : onError(error);
            }
        })();
    }, [loadAction, onError]);
    useEffect(loadCallback, [loadCallback]);
    return { loadingState, reload: loadCallback };
};
//# sourceMappingURL=use-load-action.js.map